import { Injectable } from '@angular/core';
import { SaveService } from 'src/app/_provider/save.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { WorkerTicket } from './worker-ticket.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkerExistingTicketService implements WorkerTicket {

  public isExisting: boolean = true

  constructor(
    private ticketSrv: TicketEmployee.TicketService,
    private saveSrv: SaveService.Ticket,
  ) { 
   
  }

  checkedHasChanged: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null)
  selectedEmployees?: number[];
  selectedGroups?: number[];

  public isEmployeeChecked(id: number): boolean {
    if(!this.ticketSrv.ticket.activeEmployees) return false
    if(this.ticketSrv.ticket.activeEmployees.find(e => e == id)) return true
    return false
  }
  
  public isEmployeeGroupeChecked(id: number): boolean {
    if(!this.ticketSrv.ticket.activeEmployeeGroupes) return false
    if(this.ticketSrv.ticket.activeEmployeeGroupes.find(e => e == id)) return true
    return false
  }
  
  public isEmployeeObserverChecked(id: number): boolean {
    if(!this.ticketSrv.ticket.activeObserverEmployees) return false
    if(this.ticketSrv.ticket.activeObserverEmployees.find(e => e == id)) return true
    return false
  }

  public isEmployeeGroupObserverChecked(id: number): boolean {
    if(!this.ticketSrv.ticket.activeObserverEmployeeGroups) return false
    if(this.ticketSrv.ticket.activeObserverEmployeeGroups.find(e => e == id)) return true
    return false
  }
  
  public async checkEmployee(id: number, isObserver: boolean, event?: any): Promise<void> {
    if(event) event.stopPropagation();
    const isChecked: boolean = isObserver ? this.isEmployeeObserverChecked(id) : this.isEmployeeChecked(id);
    const activeEmployees: number[] = isObserver ? this.ticketSrv.ticket.activeObserverEmployees : this.ticketSrv.ticket.activeEmployees;
    
    if (!isChecked) {
      const newActiveEmployees = [...activeEmployees, id];
      isObserver ? this.ticketSrv.ticket.activeObserverEmployees = [...newActiveEmployees] : this.ticketSrv.ticket.activeEmployees = [...newActiveEmployees];
      await this.saveSrv.saveOrDeleteEditor(id, true, undefined, undefined, isObserver);
    } else {
      const employeeIndex = activeEmployees.indexOf(id);
      const newActiveEmployees = [...activeEmployees.slice(0, employeeIndex), ...activeEmployees.slice(employeeIndex + 1)];
      isObserver ? this.ticketSrv.ticket.activeObserverEmployees = [...newActiveEmployees] : this.ticketSrv.ticket.activeEmployees = [...newActiveEmployees];
      await this.saveSrv.saveOrDeleteEditor(id, false, undefined, undefined, isObserver);
    }
    setTimeout(() =>  this.checkedHasChanged.next(true), 100)
  }
  
  public async checkEmployeeGroupe(id: number, isObserver: boolean, event?: any): Promise<void> {
    if(event) event.stopPropagation();
    const isChecked: boolean = isObserver ? this.isEmployeeGroupObserverChecked(id) : this.isEmployeeGroupeChecked(id);
    const activeGroups: number[] = isObserver ? this.ticketSrv.ticket.activeObserverEmployeeGroups : this.ticketSrv.ticket.activeEmployeeGroupes;
    
    if(!isChecked) {
      const newActiveGroups= [...activeGroups, id];
      isObserver ? this.ticketSrv.ticket.activeObserverEmployeeGroups = [...newActiveGroups] : this.ticketSrv.ticket.activeEmployeeGroupes = [...newActiveGroups];
      await this.saveSrv.saveOrDeleteGroupe(id, true, undefined, undefined, isObserver);
    } else{
      const groupIndex = activeGroups.indexOf(id);
      const newActiveGroups = [...activeGroups.slice(0, groupIndex), ...activeGroups.slice(groupIndex + 1)];
      isObserver ? this.ticketSrv.ticket.activeObserverEmployeeGroups = [...newActiveGroups] : this.ticketSrv.ticket.activeEmployeeGroupes = [...newActiveGroups];
      await this.saveSrv.saveOrDeleteGroupe(id, false, undefined, undefined, isObserver);
    }
    setTimeout(() =>  this.checkedHasChanged.next(true), 100)
  }

  
}
